// extracted by mini-css-extract-plugin
module.exports = {"input":"AddUser_input__12kiK"};